import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-navy text-white">
      <div className="container-bespoke py-24">
        {/* Top Section */}
        <div className="grid lg:grid-cols-2 gap-16 mb-24">
          {/* Left - Brand */}
          <div>
            <Link to="/" className="inline-block mb-8">
              <img 
                src="/logo.png" 
                alt="Rota Maritime Agency" 
                className="h-20 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-slate-400 max-w-md leading-relaxed">
              {language === 'en' 
                ? 'Connecting vessels to Turkish ports with precision and expertise since 1990. The silent force of Turkish maritime operations.'
                : 'Соединяем суда с турецкими портами с точностью и опытом с 1990 года.'}
            </p>
          </div>

          {/* Right - Contact */}
          <div className="lg:text-right">
            <p className="text-editorial text-slate-500 mb-4">
              {language === 'en' ? 'Operations Center' : 'Операционный центр'}
            </p>
            <a href="tel:+903682618874" className="font-mono text-2xl text-white hover:text-signal transition-colors block mb-2">+90 368 261 88 74</a>
            <a href="mailto:info@rotaship.com" className="font-mono text-slate-400 hover:text-white transition-colors block">info@rotaship.com</a>
            <p className="text-editorial text-slate-500 mt-6">24/7</p>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-24">
          <div>
            <p className="text-editorial text-slate-500 mb-6">
              {language === 'en' ? 'Navigation' : 'Навигация'}
            </p>
            <ul className="space-y-4">
              {[
                { href: '/', label: t('nav.home') },
                { href: '/about', label: t('nav.about') },
                { href: '/services', label: language === 'en' ? 'Services' : 'Услуги' },
                { href: '/fleets', label: t('nav.fleets') },
                { href: '/careers', label: language === 'en' ? 'Careers' : 'Карьера' },
                { href: '/contact', label: t('nav.contact') },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-editorial text-slate-500 mb-6">
              {language === 'en' ? 'Services' : 'Услуги'}
            </p>
            <ul className="space-y-4">
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1 group">
                  Port Agency
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1 group">
                  Cruise Agency
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1 group">
                  Yacht Agency
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-white transition-colors inline-flex items-center gap-1 group">
                  Ship Supply
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-editorial text-slate-500 mb-6">
              {language === 'en' ? 'Headquarters' : 'Офис'}
            </p>
            <p className="text-slate-400 leading-relaxed">
              Meydankapi Mah. Denizcileryolu<br />
              No:1 Daire: 1-2<br />
              Sinop, Türkiye
            </p>
          </div>

          <div>
            <p className="text-editorial text-slate-500 mb-6">
              {language === 'en' ? 'Connect' : 'Связь'}
            </p>
            <ul className="space-y-4">
              <li><a href="https://instagram.com/rotamaritime/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">Instagram</a></li>
              <li><a href="https://x.com/rotamaritime" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">Twitter / X</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Rota Maritime Agency
          </p>
          <span className="font-mono text-xs text-slate-600 mt-4 md:mt-0">
            42°01'N 35°08'E
          </span>
        </div>
      </div>
    </footer>
  );
};
